<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppShell from '@/components/shell/AppShell.vue';
import { useAuthStore } from '@/stores/auth';
import { useGlobalShortcuts } from '@/composables/useGlobalShortcuts';

const auth = useAuthStore();
const route = useRoute();

useGlobalShortcuts();

const useShell = computed(() => {
  const standalone = new Set(['login']);
  return auth.isAuthenticated && !standalone.has(String(route.name));
});
</script>

<template>
  <AppShell v-if="useShell">
    <RouterView />
  </AppShell>
  <RouterView v-else />
</template>
